import WorkerApiService from "../../workerApiServices";

class FluxoCaixaPrevistoService extends WorkerApiService {
 
    constructor() {
        super('/api/fluxoCaixaPrevisto')
    }

    getMensal(dataInicial, dataFinal){
        let params = `?`
        params = `${params}&dataInicial=${dataInicial}`
        params = `${params}&dataFinal=${dataFinal}`
        return this.get(`/getMensal${params}`)
    }

    getDetalhamento(obj){
        return this.post(`/getDetalhamento`, obj)
    }

    getDetalhamentoUnificacaoSaida(idUnificacao){
        let params = `?`
        params = `${params}&idUnificacao=${idUnificacao}`
        return this.get(`/getDetalhamentoUnificacaoSaida${params}`)
    }

    unificarLancamentos(lancamentos){
        return this.post(`/unificarLancamentos`, lancamentos)
    }

    desunificarLancamentos(lancamentos){
        return this.post(`/desunificarLancamentos`, lancamentos)
    }

}

export default FluxoCaixaPrevistoService